<ng-container>



  <!-- <td [@fadeIn] [attr.title]="inspection.CustomerName">{{inspection.CustomerName }}</td> -->


</ng-container>
<!-- <ng-container *ngIf="loadingRow">
  <td colspan="10">
    <div class="ph-item" style="height: 33px;">
      <div class="ph-row">
        <div class="ph-col-12"></div>
      </div>
    </div>
  </td>
</ng-container> -->
